module.exports = __webpack_public_path__ + "static/fonts/AvenirBold.3cec58f.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/avenir/AvenirBold.woff
// module id = cCTM
// module chunks = 1